export class LoginVm {
    Username: string;
    Password: string;
    Grant_type:string;
    Scope:string
}